import { useContext } from 'react';

import { XYChartIdContext } from '../context/XYChartId.context.js';

export const useXYChartId = () => {
  const context = useContext(XYChartIdContext);

  if (context === undefined) {
    throw new Error('useXYChartId must be used within a XYChartIdContext');
  }

  return context;
};
